import type { Middleware, MiddlewareAPI } from '@reduxjs/toolkit'

import { getProductManagement } from '@DataManagement/utils/product'

import { type baseApi } from '../api'
import {
  initializeFeedManagement,
  initializeShopifyManagement,
  refreshFeedSource,
  setDisabledProductManagements,
} from '../slices/dataManagementSlice'

export const setProductSourceMiddleware: (api: typeof baseApi) => Middleware =
  (api: typeof baseApi) =>
  ({ getState, dispatch }: MiddlewareAPI) =>
  (next: any) =>
  (action: any) => {
    const result = next(action)

    if (!api.endpoints.me.matchFulfilled(action)) {
      return result
    }

    const {
      selectedProductManagement,
      disabledProductManagements,
      isProductManagementAlreadySet,
    } = getState().dataManagement
    const { isShopify, conveyorTarget } = action.payload

    // A `me` refetch must not clobber a selection the user already made this
    // session (source + disabled flags). The feed's own data still has to
    // follow the server, though: saving a schedule invalidates `me`, and
    // bailing out entirely here left the panel rendering the pre-save target
    // until a full page reload — which is what made the "sync is disabled"
    // warning outlive enabling sync.
    if (isProductManagementAlreadySet) {
      if (conveyorTarget?.id) {
        dispatch(refreshFeedSource(conveyorTarget))
      }

      return result
    }

    if (isShopify) {
      dispatch(
        initializeShopifyManagement({
          management: getProductManagement('shopify'),
        }),
      )
    } else if (conveyorTarget && conveyorTarget?.id) {
      dispatch(
        initializeFeedManagement({
          management: getProductManagement('feed'),
          source: conveyorTarget,
        }),
      )
    } else if (
      !selectedProductManagement &&
      disabledProductManagements.length === 0
    ) {
      dispatch(setDisabledProductManagements(['shopify']))
    }

    return result
  }
